// RedirectPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { loginLinkedinUser } from "../apis/apiList/linkedinApi";
import { useMessage } from "../context/MessageContext";
import { useApp } from "../context/AppContext";


export default function RedirectPage() {
  const navigate = useNavigate();
  const { showMessage } = useMessage();
    const { login } = useApp();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userId = params.get("userId");
    const token = params.get("token");

    async function loginLinkedinUsers() {
        const res = await loginLinkedinUser({ userId, token });
        console.log("LinkedIn login response:", res);
        if (res.success) {
          login(res.user);
          if(res.user.role == 'admin'){
            navigate("/task/list");
          } else {
            if(res.user.orgId) {
                navigate(`/subs/org/${res.user.orgId}/projects`);
            } else {
                navigate("/select-organization");
            }
          }
          // showMessage("User logged in successfully", "success");
        }
    }

    if (userId && token) {
        loginLinkedinUsers();
    } else {
      navigate("/");
    }
  }, [navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      textAlign="center"
    >
      <CircularProgress size={50} sx={{ mb: 2 }} />
      <Typography variant="h6">Redirecting you to your dashboard...</Typography>
    </Box>
  );
}
